import { Stack } from "@mui/material";
import { Fragment, useState } from "react";
import { PrimaryLinearProgress } from "react-common-ui-library/FPACT/LinearProgress";
import { useIntl } from "react-intl";
import { useNavigate } from "react-router-dom";
import {
  ACCOUNT_CREATION_ROUTE,
  BACK_BUTTON_TEXT,
  CONSUMER_VIEW,
  H1,
  H3,
  PROGRESS_LABEL,
  SPACING_3_5,
  SPACING_4_5,
} from "../../../Constants/CommonConstants";
import {
  NAME_AND_CONTACT_COMPLETION_FRACTION,
  NAME_AND_CONTACT_HEADER,
  NAME_AND_CONTACT_PROGRESS_VALUE,
} from "../../../Constants/NameAndContactConstants";
import { StyledTypographyHeader } from "../../../Styles/Common/CommonStyles";
import AccountAlreadyExistsModal from "../Modals/AccountAlreadyExistsModal/AccountAlreadyExistsModal";
import NameAndContactInfoForm from "./NameAndContactInfoForm";

/**
 * @description Main contact and info page that collects user basic details for account creation
 * @returns {ReactNode} Render the linear progress on the UI along with the form inputs and selection card to collect user basic details.
 */

const NameAndContactInfo = () => {
  const intl = useIntl();

  const navigate = useNavigate();

  const [isAccountAlreadyExists, setIsAccountAlreadyExists] = useState(false);

  const navigateToAccountHome = () => {
    navigate(`/${ACCOUNT_CREATION_ROUTE}`);
  };

  return (
    <Fragment>
      <Stack spacing={SPACING_4_5}>
        <PrimaryLinearProgress
          progressValue={NAME_AND_CONTACT_PROGRESS_VALUE}
          progressLabel={PROGRESS_LABEL}
          backButtonOnClickHandler={navigateToAccountHome}
          backButtonText={BACK_BUTTON_TEXT}
          currentPage={NAME_AND_CONTACT_COMPLETION_FRACTION}
        />
        <Stack spacing={SPACING_3_5}>
          <StyledTypographyHeader
            id={NAME_AND_CONTACT_HEADER}
            component={H1}
            variant={H3}
          >
            {intl.formatMessage({
              id: NAME_AND_CONTACT_HEADER,
            })}
          </StyledTypographyHeader>
          <NameAndContactInfoForm
            setIsAccountAlreadyExists={setIsAccountAlreadyExists}
          />
        </Stack>
      </Stack>
      <AccountAlreadyExistsModal
        userView={CONSUMER_VIEW}
        open={isAccountAlreadyExists}
        setOpen={setIsAccountAlreadyExists}
      />
    </Fragment>
  );
};

export default NameAndContactInfo;
